<div *ngIf="cart">
<!-- Collapsed trigger -->
<button
    *ngIf="useExpandCollapse"
    type="button"
    (click)="toggleFold()"
    class="flex items-center text-sm font-medium text-blue-600 underline md:no-underline md:hover:underline"
    [disabled]="processingCoupon"
>
    <span *ngIf="isFolded"><fa-icon icon="caret-right" class="mr-2"></fa-icon>Add promo code to your order</span>
    <span *ngIf="!isFolded"><fa-icon icon="caret-up" class="mr-2"></fa-icon>Add promo code to your order</span>
</button>

<!-- Expandable container -->
<div
  [@expandCollapse]="useExpandCollapse ? (isFolded ? 'collapsed' : 'expanded') : 'expanded'"
>
  <div *ngIf="!useExpandCollapse || !isFolded" class="relative mt-3 p-2 bg-white">
    <div class="flex space-x-4">
        <input
            type="text"
            id="discount-code"
            name="discount-code"
            class="block w-full rounded-md bg-white px-3 py-1 text-base text-gray-900 placeholder:text-gray-400 sm:text-sm/6"
            placeholder="Promo Code"
            [(ngModel)]="couponCode"
        >
        <button
            (click)="applyCoupon()"
            type="button"
            [disabled]="!couponCode || processingCoupon"
            class="btn-primary flex w-auto ml-2"
        >Apply</button>
    </div>

    <div *ngIf="couponError" class="text-red-500 text-sm ml-2">
        {{ couponError }}
    </div>
    <div *ngIf="couponMessage" class="text-green-500 text-sm ml-2">
        {{ couponMessage }}
    </div>
  </div>
</div>
</div>
